import React from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next'; // Import useTranslation
import Login from './components/Login';
import Register from './components/Register';
import Zodiak from './components/Zodiak';
import Logout from './components/Logout';
import Contacts from './components/Contacts';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './components/Home';
import ZodiacLove from './components/ZodiacLove'; // Impor ZodiacLove
import ZodiacPersonality from './components/personality.zodiak'; // Pastikan nama file dan komponen sesuai
import ZodiacHealthAndWellness from './components/zodiacHealthAndWellness'; // Update import
import ZodiacEventsAndFestivals from './components/ZodiacEventsAndFestivals'; // Pastikan path-nya benar
import ZodiacLifestyleAndInspiration from './components/ZodiacLifestyleAndInspiration';

function App() {
  const location = useLocation();
  const { t } = useTranslation(); // Initialize useTranslation

  // Define routes where Header and Footer should not be displayed
  const noHeaderFooterRoutes = ['/login', '/register'];

  // Check if the current route is one where the Header and Footer should not be displayed
  const hideHeaderFooter = noHeaderFooterRoutes.includes(location.pathname);

  return (
    <div>
      {/* Conditionally render Header and Footer */}
      {!hideHeaderFooter && <Header />}

      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/zodiak" element={<Zodiak />} />
          <Route path="/zodiac-love" element={<ZodiacLove />} /> {/* Rute untuk ZodiacLove */}
          <Route path="/zodiac-personality" element={<ZodiacPersonality />} />
          <Route path="/zodiac-health-and-wellness" element={<ZodiacHealthAndWellness />} /> {/* Update route */}
          <Route path="/zodiac-events-festivals" element={<ZodiacEventsAndFestivals />} />
          <Route path="/zodiac-lifestyle-inspiration" element={<ZodiacLifestyleAndInspiration />} />
          <Route path="/logout" element={<Logout />} />
          <Route path="/contacts" element={<Contacts />} />
        </Routes>
      </main>

      {/* Conditionally render Footer */}
      {!hideHeaderFooter && <Footer />}
    </div>
  );
}

export default App;
